import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class AssetRequest extends BaseRequest{

  asset                 : Asset = new Asset();
  assetTransferCode     : string;
  withLinkedData        : boolean;
  withPendingTickets    : boolean;
  withoutPendingTickets : boolean;
  includeClosed         : boolean;


  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.asset = new Asset();
  }
}


